export const ACTIVE_BUTTON_CONFIG = {
  Dashboard: [
    // {
    //   label: "Engine Replacement",
    //   redirectTo: "/admin/overview?index=0",
    //   info: "Involves the removal of a vehicle's existing engine and installing a new one.",
    // },
    {
      label: "Trend Overview",
      redirectTo: "/admin/overview?index=8",
      info: "How engine replacement trend is happing over the year",
    },
  ],
  "Complaint Overview": [
    {
      label: "OEM Wise",
      redirectTo: "/admin/overview?index=2",
      info: "Know OEM wise details in charts",
    },
    {
      label: "Region Wise",
      redirectTo: "/admin/overview?index=3",
      info: "Know Region wise details in charts",
    },
    {
      label: "Engine Model Wise",
      redirectTo: "/admin/overview?index=4",
      info: "Know Engine Model wise details in charts",
    },
    {
      label: "Hour Wise",
      redirectTo: "/admin/overview?index=5",
      info: "Know Hour Wise details in charts",
    },
    {
      label: "Part Wise Trend",
      redirectTo: "/admin/overview?index=7",
      info: "Know Part Wise Trend in charts",
    },
  ],
  "Complaint Handling": [
    {
      label: "Tickets",
      redirectTo: "/admin/tickets",
      info: "you're experiencing performance issues, unusual noises, or it's time for an upgrade, our expert team is here to assist you.",
    },
    {
      label: "Reports",
      redirectTo: "/admin/reports",
      info: "where you can access comprehensive insights into the status and performance of recent service requests.",
    },
    {
      label: "Admin Settings",
      redirectTo: "/admin/setup",
      info: "users can be created, and other configurations can be managed, it's crucial to provide a user-friendly and organized interface.",
    },
  ],
};
export const INDIA_MAP_DATA = {
  "Jammu & Kashmir": {
    value: 0,
    id: "IN-JK",
    color: "#BFD165",
  },
  "Himachal Pradesh": {
    value: 0,
    id: "IN-HP",
    color: "#FFA5C4",
  },
  Punjab: {
    value: 0,
    id: "IN-PB",
    color: "#FFDD55",
  },
  Uttarakhand: {
    value: 0,
    id: "IN-UT",
    color: "#B6ACEA",
  },
  Haryana: {
    value: 0,
    id: "IN-HR",
    color: "#EFB653",
  },
  Maharashtra: {
    value: 0,
    id: "IN-MH",
    color: "#BFD165",
  },
  Rajasthan: {
    value: 0,
    id: "IN-RJ",
    color: "#FFA5C4",
  },
  "Tamil Nadu": {
    value: 0,
    id: "IN-TN",
    color: "#BFD165",
  },
  Kerala: {
    value: 0,
    id: "IN-KL",
    color: "#BCB3E9",
  },
  "Andaman & Nicobar Island": {
    value: 0,
    id: "IN-AN",
    color: "#F3B955",
  },
  "Arunanchal Pradesh": {
    value: 0,
    id: "IN-AR",
    color: "#FFA5C4",
  },
  Assam: {
    value: 0,
    id: "IN-AS",
    color: "#FDDC5A",
  },
  Bihar: {
    id: "IN-BR",
    value: 0,
    color: "#F3B955",
  },
  Chandigarh: {
    value: 0,
    id: "IN-CH",
    color: "#BCB3E8",
  },
  Chhattisgarh: {
    value: 0,
    id: "IN-CT",
    color: "#BFD165",
  },
  Delhi: {
    value: 0,
    id: "IN-DL",
    color: "#FDDD54",
  },
  Goa: {
    value: 0,
    id: "IN-GA",
    color: "#BCB5EA",
  },
  Jharkhand: {
    value: 0,
    id: "IN-JH",
    color: "#FFA4C4",
  },
  "Madhya Pradesh": {
    value: 0,
    id: "IN-MP",
    color: "#FFDD55",
  },
  Manipur: {
    value: 0,
    id: "IN-MN",
    color: "#B97C90",
  },
  Meghalaya: {
    value: 0,
    id: "IN-ML",
    color: "#FFA5C4",
  },
  Mizoram: {
    value: 0,
    id: "IN-MZ",
    color: "#BFD165",
  },
  Nagaland: {
    value: 0,
    id: "IN-NL",
    color: "#BCB3E8",
  },
  Odisha: {
    value: 0,
    id: "IN-OR",
    color: "#FFDD55",
  },
  Sikkim: {
    value: 0,
    id: "IN-SK",
    color: "#F3B955",
  },
  Telangana: {
    value: 0,
    id: "IN-TG",
    color: "#BFD165",
  },
  Tripura: {
    value: 0,
    id: "IN-TR",
    color: "#FFA5C4",
  },
  "West Bengal": {
    value: 0,
    id: "IN-WB",
    color: "#C0D163",
  },
  Gujarat: {
    value: 0,
    id: "IN-GJ",
    color: "#F3B955",
  },
  "Uttar Pradesh": {
    value: 0,
    id: "IN-UP",
    color: "#BFD165",
  },
  "Andhra Pradesh": {
    value: 0,
    id: "IN-AP",
    color: "#F3B955",
  },
  Karnataka: {
    value: 0,
    id: "IN-KA",
    color: "#FFDD55",
  },
};

export const DUMMY_STATE_DATA = [
  {
    count: 156,
    state: "Uttar Pradesh",
  },
  {
    count: 346,
    state: "Rajasthan",
  },
  {
    count: 10,
    state: "Arunanchal Pradesh",
  },
  {
    count: 5,
    state: "Jammu & Kashmir",
  },
  {
    count: 10,
    state: "Himachal Pradesh",
  },
  {
    count: 41,
    state: "Odisha",
  },
  {
    count: 45,
    state: "Telangana",
  },
  {
    count: 134,
    state: "Gujarat",
  },
  {
    count: 96,
    state: "Maharashtra",
  },
  {
    count: 54,
    state: "Andhra Pradesh",
  },
  {
    count: 95,
    state: "Karnataka",
  },
  {
    count: 69,
    state: "Bihar",
  },
  {
    count: 55,
    state: "Punjab",
  },
  {
    count: 32,
    state: "Haryana",
  },
  {
    count: 71,
    state: "Delhi",
  },
  {
    count: 162,
    state: "Tamil Nadu",
  },
  {
    count: 8,
    state: "Assam",
  },
  {
    count: 91,
    state: "Madhya Pradesh",
  },
  {
    count: 153,
    state: "Jharkhand",
  },
  {
    count: 10,
    state: "Chandigarh",
  },
  {
    count: 10,
    state: "Chhattisgarh",
  },
  {
    count: 50,
    state: "West Bengal",
  },
  {
    count: 15,
    state: "Uttarakhand",
  },
  {
    count: 4,
    state: "Kerala",
  },
];
